var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 114,
    viewBox: "0 0 126 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_3616)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1352_3616",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -135,
    width: 299,
    height: 249
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -135,
    width: 299,
    height: 249,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1352_3616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.625 0V38.25H106.875L68.625 0Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.625 47.8125C63.3561 47.8125 59.0625 43.5189 59.0625 38.25V0H1.6875C-3.58144 0 -7.875 4.29356 -7.875 9.5625V143.438C-7.875 148.716 -3.58144 153 1.6875 153H97.3125C102.591 153 106.875 148.716 106.875 143.438V47.8125H68.625ZM30.375 133.875H11.25V105.188H30.375V133.875ZM59.0625 133.875H39.9375V86.0625H59.0625V133.875ZM87.75 133.875H68.625V66.9375H87.75V133.875Z",
    fill: "white",
    fillOpacity: 0.15
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_3616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H126V114H10C4.47715 114 0 109.523 0 104V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport2);
export default __webpack_public_path__ + "static/media/Report2.9e3e718af1ee97d1d5ce354da91a24b6.svg";
export { ForwardRef as ReactComponent };